import { getApplicationSession } from '@msgn/fl-module/fl-analytics';

export const dataZoomApi = {
  init: () => {
    return getApplicationSession();
  },
};
